// Web-only strings for browser notifications and the tab badge (keys prefixed `web.notify.`).
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.notify.askTitle': 'Activa las notificaciones',
    'web.notify.askBody': 'Te avisamos de mensajes directos y menciones aunque estés en otra pestaña.',
    'web.notify.allow': 'Activar',
    'web.notify.later': 'Ahora no',
    'web.notify.replyIn': 'Respuesta en %@',
  },
  en: {
    'web.notify.askTitle': 'Turn on notifications',
    'web.notify.askBody': 'Get direct messages and mentions even while you are in another tab.',
    'web.notify.allow': 'Turn on',
    'web.notify.later': 'Not now',
    'web.notify.replyIn': 'Reply in %@',
  },
};
